import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import { FaPaw } from "react-icons/fa";
import TextField from "@material-ui/core/TextField";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Container from "@material-ui/core/Container";
import { withRouter } from "react-router";
import Tag from "./Tag";
import tags from "../tags.json";
import styles from "./searchForm.module.css";

export default withRouter(
	connect(
		(state) => state.form,
		(dispatch) => ({
			changeTextSearch: (newValue) =>
				dispatch({ type: "SET_TEXT_SEARCH", payload: newValue }),
			changeSelectedTags: (newValue) =>
				dispatch({ type: "SET_SELECTED_TAGS", payload: newValue }),
		})
	)(
		({
			textSearch,
			selectedTags,
			changeTextSearch,
			changeSelectedTags,
			history,
			inline = false,
		}) => {
			function handleOnKeyDown(event) {
				if (event.key === "Enter") {
					history.push(
						`${process.env.REACT_APP_ROOT_URL}/dealers-list`
					);
				}
			}
			return (
				<Container
					maxWidth="lg"
					className={inline ? styles.inline : undefined}
				>
					<TextField
						autoFocus={!inline}
						variant="outlined"
						label="Shop or Artist Name"
						margin="normal"
						fullWidth
						value={textSearch}
						onKeyDown={handleOnKeyDown}
						onChange={(e) => changeTextSearch(e.target.value)}
					/>
					<Autocomplete
						multiple
						id="tags-standard"
						autoHighlight
						autoComplete
						options={tags}
						defaultValue={[]}
						onKeyDown={handleOnKeyDown}
						value={selectedTags}
						onChange={(_, value) => {
							changeSelectedTags(value);
						}}
						renderTags={(tagValue, getTagProps) =>
							tagValue.map((option, index) => (
								<Tag tag={option} {...getTagProps({ index })} />
							))
						}
						renderInput={(params) => (
							<TextField
								{...params}
								variant="outlined"
								label="Tags"
								margin="normal"
								fullWidth
							/>
						)}
					/>
					{!inline && (
						<>
							<br />
							<Button
								component={Link}
								to={`${process.env.REACT_APP_ROOT_URL}/dealers-list`}
								variant="contained"
								color="primary"
								startIcon={<FaPaw />}
							>
								Search
							</Button>
						</>
					)}
				</Container>
			);
		}
	)
);
